import script from "./ConsentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentModal.vue?vue&type=script&setup=true&lang=js"

import "./ConsentModal.vue?vue&type=style&index=0&id=152d9195&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152d9195"]])

export default __exports__